Information about a person not specific to a candidate profile.
